import React from "react";
import { computed, observable } from "mobx";
import { inject, observer } from "mobx-react";
import { FormikProps, Field, FieldProps } from "formik";
import { IManagementStore } from "@src/Stores/Management/types";
import { STButtonMargin } from "@src/Components/Ui/STButtonMargin";
import { Values } from "@src/Tools/Values";
import { IValuesStore } from "@src/Stores/Values/types";
import { IProfileImageForm } from "../ProfileImage";
import {
  Button,
  Grid,
  FormHelperText
} from "@material-ui/core";
import {
  STTextField,
  STGrid,
  STButtonsGrid,
  STPreviewImage
} from "./styles";

interface IProps<T> {
  fieldName: keyof IProfileImageForm;
  formikProps: FormikProps<T>;
  management?: IManagementStore;
  values?: IValuesStore;
  imageUrl: string;
}

@inject("management", "values")
@observer
export default class FileField<T> extends React.Component<IProps<T>> {
  @observable file: any;

  triggerSubmit = () => {
    setTimeout(() => {
      this.props.formikProps.submitForm();
    }, 1);
  };

  handleFileChange = (e: any) => {
    e.persist();
    this.file = URL.createObjectURL(e.currentTarget.files[0]);
    this.props.formikProps.setFieldValue(
      this.props.fieldName as string,
      e.currentTarget.files[0]
    );
    this.triggerSubmit();
  };

  handleResetFile = (e: any) => {
    this.file = null;
    (document.querySelector("#fileInput") as HTMLInputElement).value = null;
    this.props.formikProps.setFieldValue(
      this.props.fieldName as string,
      new File([], "reset")
    );
    this.triggerSubmit();
  };

  handleOpen = (e: any) => {
    const fileNode: any = document.querySelector("#fileInput");
    fileNode.click();
  };

  @computed get previewImageSrc() {
    if (this.file) {
      return this.file;
    }
    return "";
  }

  @computed get isError() {
    return (
      this.props.formikProps.touched[this.props.fieldName] &&
      !!this.props.formikProps.errors[this.props.fieldName]
    );
  }

  componentDidMount() {
    if (this.props.imageUrl) {
      this.file = `${this.props.values.filesPath}${this.props.imageUrl}`;
    }
  }

  render() {
    return (
      <>
        <Field
          name={this.props.fieldName}
          render={({ field }: FieldProps) => (
            <STTextField
              type="file"
              fullWidth
              onChange={this.handleFileChange}
              id="fileInput"
              inputProps={{
                accept: "image/*",
              }}
            />
          )}
        />
        
        <STGrid container justify="flex-start" alignItems="center">
          {this.previewImageSrc && <Grid item>
            <STPreviewImage src={this.previewImageSrc} alt="" />
          </Grid>}
          
          { this.file
            ?
            <STButtonsGrid item container alignItems="center">
              <Grid item>
                <STButtonMargin
                  variant="contained"
                  color="primary"
                  onClick={this.handleOpen}>
                  {Values.getLocalizationValue("change")}
                </STButtonMargin>
              </Grid>
              <Grid item>
                <STButtonMargin
                  variant="contained"
                  color="secondary"
                  onClick={this.handleResetFile}>
                  {Values.getLocalizationValue("remove")}
                </STButtonMargin>
              </Grid>
            </STButtonsGrid>
            :
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                onClick={this.handleOpen}>
                {Values.getLocalizationValue("selectPicture")}
              </Button>
            </Grid>
          }
          
          <Grid item xs={12}>
            {this.isError && (
              <FormHelperText error={true}>
                {this.props.formikProps.touched[this.props.fieldName] &&
                  this.props.formikProps.errors[this.props.fieldName]}
              </FormHelperText>
            )}
          </Grid>
        </STGrid>
      </>
    );
  }
}
